import { useMemo } from "react";
import { DateTime } from "luxon";
import { useTranslation } from "react-i18next";
import { DateInput, TimeInput } from "./TimeInput";

const StopDateTimeFields = (props: {
  dateFieldLabel: string;
  timeFieldLabel: string;
  value: DateTime;
  onChange: (newDate: DateTime) => void;
  timeError?: boolean;
  dateError?: boolean;
}) => {
  const { t } = useTranslation("addDropoffPage");

  const timeAsString = useMemo(
    () => props.value.toFormat("HH:mm"),
    [props.value]
  );

  return (
    <div className="flex flex-col gap-1">
      <DateInput
        value={props.value.toISODate()}
        onChange={(e) => {
          if (!e.target.value) return;
          const parsedDate = DateTime.fromISO(e.target.value);
          props.onChange(
            props.value.set({
              year: parsedDate.get("year"),
              month: parsedDate.get("month"),
              day: parsedDate.get("day"),
            })
          );
        }}
        label={props.dateFieldLabel}
      />
      {props.dateError && (
        <div style={{ color: "red", marginBottom: 8 }}>
          {t("pickupDropoffTimeError")}
        </div>
      )}
      <TimeInput
        value={timeAsString}
        onChange={(e) => {
          if (!e.target.value) return;
          const time = DateTime.fromFormat(e.target.value, "HH:mm");
          props.onChange(
            props.value.set({
              hour: time.get("hour"),
              minute: time.get("minute"),
            })
          );
        }}
        label={props.timeFieldLabel}
      />
      {props.timeError && (
        <div style={{ color: "red", marginBottom: 8 }}>
          {t("pickupDropoffTimeError")}
        </div>
      )}
    </div>
  );
};

export default StopDateTimeFields;
